import SoftBox from 'components/SoftComponents/SoftBox';
import SoftTypography from 'components/SoftComponents/SoftTypography';
import { Icon } from '@mui/material';
import { Link } from 'react-router-dom';

const GroupMapSidebar = ({ groups, hoveredGroupId, setHoveredGroupId, canEditGroup, onEditGroup, canRemoveGroup, onRemoveGroup }) => {
    return (
        <SoftBox sx={{
            flex: '0 0 auto',
            width: { xxs: '100%', sm: '350px', md: '400px', lg: '450px', xl: '500px', xxl: '25vw' },
            maxWidth: { xxl: '600px' },
            height: '100%',
            backgroundColor: '#f8f9fa',
            borderRight: { md: '1px solid #ddd' },
            borderBottom: { xxs: '1px solid #ddd', md: 'none' },
            display: 'flex',
            flexDirection: 'column',
            zIndex: 10
        }}>
            <SoftBox sx={{ padding: '20px', borderBottom: '1px solid #e2e8f0', backgroundColor: '#fff' }}>
                <SoftTypography variant="h5" sx={{ margin: '0 0 5px 0', fontWeight: 'bold' }}>
                    Created Groups
                </SoftTypography>
                <SoftTypography variant="body2" sx={{ color: '#666', fontSize: '13px' }}>
                    Hover over a group to highlight it on the map and view its devices.
                </SoftTypography>
            </SoftBox>

            <SoftBox sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
                {groups.length === 0 ? (
                    <SoftTypography sx={{ fontStyle: 'italic', color: '#999', fontSize: '14px' }}>
                        No groups available.
                    </SoftTypography>
                ) : (
                    <SoftBox sx={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {groups.map((group) => (
                            <SoftBox
                                key={group.group_id}
                                onMouseEnter={() => setHoveredGroupId(group.group_id)}
                                onMouseLeave={() => setHoveredGroupId(null)}
                                mb={1.25} p={1.5}
                                sx={{
                                    background: hoveredGroupId === (group.group_id) ? '#e9ecef' : '#fff',
                                    borderRadius: '6px',
                                    border: hoveredGroupId === (group.group_id) ? '1px solid #ced4da' : '1px solid transparent',
                                    borderLeft: `4px solid ${group?.color || '#17c1e8'}`,
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                    transition: 'background-color 0.2s ease',
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                }}
                            >
                                {group.type == "monitoring" ? (
                                    <SoftBox component={Link} to={`/groups/${group.group_id}`} sx={{ minWidth: 'calc(100% - 34px)', textDecoration: 'none' }}>
                                        <SoftTypography fontWeight="bold" sx={{ display: 'block', fontSize: '15px' }}>
                                            {group.name}
                                        </SoftTypography>
                                        <SoftTypography textTransform="capitalize" sx={{ display: 'block', lineHeight: 1.2, fontSize: '11px', color: '#999' }}>
                                            {group.type} Group
                                        </SoftTypography>
                                        {group.sites?.length ? (
                                            <SoftTypography sx={{ fontSize: '13px', color: '#666', mt: 1 }}>
                                                {group.sites?.length || 0} Sites Included
                                            </SoftTypography>
                                        ) : group.uuids?.length ? (
                                            <SoftTypography sx={{ fontSize: '13px', color: '#666', mt: 1 }}>
                                                {group.uuids?.length || 0} Devices Included
                                            </SoftTypography>
                                        ) : (
                                            <SoftTypography sx={{ fontSize: '13px', color: '#666', mt: 1 }}>
                                                {0} Locations Included
                                            </SoftTypography>
                                        )}
                                    </SoftBox>
                                ) : (
                                    <SoftBox sx={{ minWidth: 'calc(100% - 34px)', textDecoration: 'none' }}>
                                        <SoftTypography fontWeight="bold" sx={{ display: 'block', fontSize: '15px' }}>
                                            {group.name}
                                        </SoftTypography>
                                        <SoftTypography textTransform="capitalize" sx={{ display: 'block', lineHeight: 1.2, fontSize: '11px', color: '#999' }}>
                                            {group.type} Group
                                        </SoftTypography>
                                        {group.sites?.length ? (
                                            <SoftTypography sx={{ fontSize: '13px', color: '#666', mt: 1 }}>
                                                {group.sites?.length || 0} Sites Included
                                            </SoftTypography>
                                        ) : group.uuids?.length ? (
                                            <SoftTypography sx={{ fontSize: '13px', color: '#666', mt: 1 }}>
                                                {group.uuids?.length || 0} Devices Included
                                            </SoftTypography>
                                        ) : (
                                            <SoftTypography sx={{ fontSize: '13px', color: '#666', mt: 1 }}>
                                                {0} Locations Included
                                            </SoftTypography>
                                        )}
                                    </SoftBox>
                                )}
                                <SoftBox>
                                    {canEditGroup && (
                                        <SoftBox onClick={() => onEditGroup(group.group_id)} sx={({ typography: { fontFamily } }) => ({ fontFamily, display: 'flex', padding: '0.5rem !important', color: '#666', cursor: 'pointer', fontSize: '18px' })}><Icon>edit</Icon></SoftBox>
                                    )}
                                    {canRemoveGroup && (
                                        <SoftBox onClick={() => onRemoveGroup(group.group_id)} sx={({ typography: { fontFamily } }) => ({ fontFamily, display: 'flex', padding: '0.5rem !important', color: '#e74c3c', cursor: 'pointer', fontSize: '18px' })}><Icon>close</Icon></SoftBox>
                                    )}
                                </SoftBox>
                            </SoftBox>
                        ))}
                    </SoftBox>
                )}
            </SoftBox>
        </SoftBox>
    );
};

export default GroupMapSidebar;